export default "__VITE_ASSET__DtL73rev__"